import _isEmpty from 'lodash/isEmpty';

export const TEL_URI_SCHEME = 'tel://';
export const TEL_URI_STARTS_WITH = 'tel';
export const MAILTO_URI_SCHEME = 'mailto://';
export const MAILTO_URI_STARTS_WITH = 'mailto';
export const HTTP_URI_SCHEME = 'https://';
export const HTTP_URI_STARTS_WITH = 'http';
export const HTTP_URI_STARTS_WITH_WWW = 'www';
export const SMS_URI_SCHEME = 'sms:';
export const SMS_URI_STARTS_WITH = 'sms';

export const NEED_ENCODING_URI_SCHEMES = [SMS_URI_SCHEME];

export function needEncoding(scheme) {
  return NEED_ENCODING_URI_SCHEMES.includes(scheme);
}

export function stripScheme(uri) {
  if (typeof uri === 'string') {
    return uri.replace(/^(https?|mailto|tel|sms)/, '').replace(/(:)|(\/\/)/g, '');
  }

  return uri;
}

export function isMailTo(uri) {
  return uri.startsWith(MAILTO_URI_STARTS_WITH);
}

export function isTel(uri) {
  return uri.startsWith(TEL_URI_STARTS_WITH);
}

export function isSms(uri) {
  return uri.startsWith(SMS_URI_STARTS_WITH);
}

export function isHttp(uri) {
  return uri.startsWith(HTTP_URI_STARTS_WITH) || uri.startsWith(HTTP_URI_STARTS_WITH_WWW);
}

export function getSchemeFromValue(uri, { defaultScheme = null } = {}) {
  if (_isEmpty(uri)) {
    return HTTP_URI_SCHEME;
  }
  if (isMailTo(uri)) {
    return MAILTO_URI_SCHEME;
  }
  if (isTel(uri)) {
    return TEL_URI_SCHEME;
  }
  if (isSms(uri)) {
    return SMS_URI_SCHEME;
  }
  if (isHttp(uri)) {
    return HTTP_URI_SCHEME;
  }

  return defaultScheme;
}

function handleUriEncoding(uri, encodingFunction) {
  try {
    const url = new URL(uri);
    const params = url.searchParams;

    const newParams = [];
    Array.from(params.entries()).forEach(([key, value]) => {
      newParams.push(`${key}=${encodingFunction(value)}`);
    });

    const hasParams = !_isEmpty(newParams);
    if (!hasParams) {
      return uri;
    }

    const { href, hash } = url;

    let hrefNoParams = href.split('?')[0];
    hrefNoParams = hrefNoParams.endsWith('/') ? hrefNoParams.slice(0, -1) : hrefNoParams;

    const encodedUri = [hrefNoParams, `?${newParams.join('&')}`, hash]
      .filter((value) => !_isEmpty(value) && value !== 'null')
      .join('');

    return encodedUri;
  } catch {
    return uri;
  }
}

export function encodeUri(uri) {
  return handleUriEncoding(uri, encodeURIComponent);
}

export function decodeUri(uri) {
  return handleUriEncoding(uri, decodeURIComponent);
}

export function ensureTrailingSlash(url) {
  if (!url) return url;
  return url.endsWith('/') ? url : `${url}/`;
}
